import { render, staticRenderFns } from "./PcImage.vue?vue&type=template&id=e389a55a"
import script from "./PcImage.vue?vue&type=script&lang=js"
export * from "./PcImage.vue?vue&type=script&lang=js"
import style0 from "./PcImage.vue?vue&type=style&index=0&id=e389a55a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDialog,VSkeletonLoader})
